export default "__VITE_ASSET__DZYxQyjq__"